import { render, staticRenderFns } from "./faultappe.vue?vue&type=template&id=4e9fd4ac&scoped=true&"
import script from "./faultappe.vue?vue&type=script&lang=js&"
export * from "./faultappe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9fd4ac",
  null
  
)

export default component.exports